<template>
  <div />
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ImportStatusConstant from '@/constant/importStatus'
import EventBus from '@/eventBus'
import Utils from '@/util'
import VueToastedUtils from '@/utils/vue-toasted.utils.js'
import eventCategories from '@/constant/eventCategories'
import { IMPORT_DOCUMENT } from '@/constant/eventActions'

export default {
  data() {
    return {
      failureReason: null,
      currentToast: null,
    }
  },
  computed: {
    ...mapGetters('docToSlideGenerator', [
      'docToSlideImportStage',
      'isDocToSlideImportModalVisible',
      'docToSlideUniqueRequestId',
      'isDocToSlideResultModalVisible',
      'docToSlideResponse',
    ]),
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      importStatus: (state) => state.importStatus,
    }),
    isShowingResultModal() {
      const status = [ImportStatusConstant.UPLOADING, ImportStatusConstant.CONVERTING]
      return this.docToSlideResponse.length > 0 && this.isDocToSlideResultModalVisible &&
      !status.includes(this.docToSlideImportStage)
    },
    isImportingDocument() {
      return this.importStatus === 2 || this.importStatus === 3
    },
    toastUniqueClass() {
      return `custom-toast__${this.docToSlideUniqueRequestId}`
    },
  },
  watch: {
    isShowingResultModal() {
      this.closeToast()
    },
  },
  mounted() {
    this.currentToast = document.getElementsByClassName(this.toastUniqueClass)
    if (!this.currentToast || !this.currentToast.length) {
      this.showVueToast()
    }
    EventBus.$on('doc-to-quiz: reset_all_results', () => {
      this.resetAllResults()
    })
    EventBus.$on('doc-to-quiz: close_generating_toast', (preventTracking) => {
      this.closeToast(preventTracking)
    })
    EventBus.$on('doc-to-slide: show_toast_error', (error) => {
      this.showToastError(error)
    })
  },
  destroyed() {
    EventBus.$off('doc-to-quiz: reset_all_results')
    EventBus.$off('doc-to-quiz: close_generating_toast')
    EventBus.$off('doc-to-slide: show_toast_error')
  },
  methods: {
    ...mapActions('docToSlideGenerator', [
      'setDocToSlideImportStageAction',
      'toggleDocToSlideImportModalAction',
      'generateDocToSlideUniqueRequestIdAction',
      'toggleDocToSlideResultModalAction',
      'setDocToSlideResponseAction',
    ]),

    async showToastError(error) {
      if (error) {
        this.failureReason = error
      }
      Utils.showToastError(this.$i18nPresenter.t('Can’t generate quiz at the moment.'))
      // this.closeToast(true)
      await Utils.sleep(1000)
      this.generateDocToSlideUniqueRequestIdAction(null)
      this.setDocToSlideImportStageAction(ImportStatusConstant.NO_IMPORT)
      this._trackDocToQuizGenerationError()
    },

    _getFailureReason() {
      if (this.failureReason) {
        return this.failureReason
      }
      if (this.docToSlideImportStage === ImportStatusConstant.ERROR_REACH_LIMIT) {
        return 'Reach limit of 50MB or 100 slides'
      }
      if (this.docToSlideImportStage === ImportStatusConstant.ERROR_UNSUPPORTED_FILE_TYPE) {
        return 'Unsupported file type'
      }
      return 'Unknown'
    },

    _trackDocToQuizGenerationError() {
      const failureReason = this._getFailureReason()
      const eventAction = `${IMPORT_DOCUMENT} > Failure`
      const trackData = {
        eventAction,
        eventCategory: eventCategories.PRESENTATION_EDITOR,
        isGenerateQuizFromThisDocument: this.needGenerateQuiz,
        failureReason,
        presentationId: this.presentation.id,
        userId: this.currentUser.id,
      }
      Utils.trackGA4AndMixpanel(eventAction, trackData)
    },

    resetAllResults() {
      this.failureReason = null
      this.setDocToSlideResponseAction([])
    },

    closeToast() {
      if (this.currentToast && this.currentToast[0]) {
        this.currentToast[0].parentNode.removeChild(this.currentToast[0])
      }
    },

    async showVueToast() {
      VueToastedUtils.showToast(this.$i18nPresenter.t('Generating some questions by AI…'), {}, {
        className: ['custom-toast__loading', this.toastUniqueClass],
        hasReturnValue: true,
        action: {
          text: this.$i18nPresenter.t('View'),
          class: 'custom-toast__loading-url',
          onClick: () => {
            if (this.isDocToSlideImportModalVisible) return
            this.toggleDocToSlideImportModalAction(true)
          },
        },
      })
      this.currentToast = document.getElementsByClassName(this.toastUniqueClass)
    },
  },
}
</script>

<style lang="scss" scoped>
.doc-to-quiz__status-box {
  @apply absolute z-10 bottom-2 right-2;
  width: 350px;
}
.status-box__generating {
  @apply flex rounded p-3 bg-primary-50 border border-secondary-20;
}
.status-box__successful {
  @apply flex rounded p-3 bg-green-10 border border-secondary-20;
}
</style>
